import React from 'react';

const NappErrorMessage = ({ error }) => error ?
  <div className="error-bg" style={{ margin: 5, marginTop: 0, marginBottom: 10, paddingLeft: 10, paddingRight: 10 }}>
    <p>{error.message}</p>
  </div> : null

export default NappErrorMessage;